import Cookies from "js-cookie";

export default class CookieForm {
  constructor(app) {
    this.app = app;

    this.cookieName = "park2020";
    this.cookieMarketingSuffix = "m";
    this.cookieAnalyticsSuffix = "a";

    this.cookieForm = document.querySelector(".js-cookie-form");
    this.cookieCheckboxAnalytics = document.querySelector(
      ".js-cookie-analytics"
    );
    this.cookieCheckboxMarketing = document.querySelector(
      ".js-cookie-marketing"
    );

    this.init();
  }

  init() {
    this.events();
    this.setCookiesStatus();
  }

  events() {
    this.cookieForm.addEventListener("submit", this.onSubmit.bind(this));
  }

  destroy() {}

  onSubmit(e) {
    e.preventDefault();

    if (this.cookieCheckboxAnalytics) {
      if (!this.cookieCheckboxAnalytics.checked) {
        Cookies.remove("_ga");
        Cookies.remove("_ga_KGNRHT52G2");
        Cookies.remove("_gid");
        Cookies.remove("_fbp");
      }
    }

    if (this.cookieCheckboxMarketing) {
      if (!this.cookieCheckboxMarketing.checked) {
        //
      }
    }

    Cookies.set(`${this.cookieName}`, true, {
      expires: 365,
      secure: false,
    });

    if (this.cookieCheckboxAnalytics) {
      Cookies.set(
        `${this.cookieName}-${this.cookieAnalyticsSuffix}`,
        this.cookieCheckboxAnalytics.checked,
        {
          expires: 365,
          secure: false,
        }
      );
    }

    if (this.cookieCheckboxMarketing) {
      Cookies.set(
        `${this.cookieName}-${this.cookieMarketingSuffix}`,
        this.cookieCheckboxMarketing.checked,
        {
          expires: 365,
          secure: false,
        }
      );
    }

    window.location.reload();
  }

  setCookiesStatus() {
    const analyticsCookie = Cookies.getJSON(
      `${this.cookieName}-${this.cookieAnalyticsSuffix}`
    );
    const marketingCookie = Cookies.getJSON(
      `${this.cookieName}-${this.cookieMarketingSuffix}`
    );
    if (this.cookieCheckboxAnalytics) {
      this.cookieCheckboxAnalytics.checked = analyticsCookie || false;
    }
    if (this.cookieCheckboxMarketing) {
      this.cookieCheckboxMarketing.checked = marketingCookie || false;
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/cookieForm.js